import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { all, put, call, select, takeEvery } from 'redux-saga/effects';
import { flagEnabled } from '@wix/da-react-context/pkg/flags/redux/selectors';
import { deleteStatus, submitStatus, submitStatusSuccess, submitStatusFailure } from './actions';
import { isApiError, requestNapi, requestPuppy } from '@wix/da-http-client';
import { normalize } from '../redux/normalizr';
import { putEntities } from '../redux/entities/actions';
import { deviationSchema } from '../redux/normalizr/schemas/deviation';
import ddt from '@wix/da-ddt';
import { getDeviationUrl } from '../DeviationViews/_helpers';
import { editDeviationSuccess } from '../redux/deviations/actionCreators';
import { logBiEvent } from '../biLogger/redux/saga';
import { ResourceType } from '../types/resource';
import { PureBiData } from '@wix/da-bi/pkg/events';
export function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error'
            };
        }
        ddt.log('statusupdate', 'faking the response!');
        const { deviationsByType } = require('@wix/da-sample-data'); // eslint-disable-line global-require
        const deviation = deviationsByType.statuses[0];
        if (options.url === '/status/create' || options.url === '/status/update') {
            deviation.status.textContent = {
                excerpt: options.data.editorSnippet,
                html: {
                    type: 'draft',
                    markup: JSON.parse(options.data.editorRaw),
                    features: JSON.parse(options.data.editorFeatures)
                }
            };
        }
        return {
            deviation
        };
    }
}
function* submitStatusSaga(action) {
    const { editorRawState, statusId: statusid, backgroundProps = {}, refreshAfterSubmit, visibility } = action.payload;
    ddt.log('statusupdate', 'payload', action.payload);
    const isEdit = statusid !== undefined;
    const { backgroundType, gradient, imageDisplayMode, imageTint, pattern, imageDeviation } = backgroundProps;
    const snakeCaseBackgroundParams = {
        background_type: backgroundType,
        image_tint: imageTint,
        image_deviationid: imageDeviation === null || imageDeviation === void 0 ? void 0 : imageDeviation.deviationId,
        image_display_mode: imageDisplayMode,
        gradient: gradient,
        pattern: pattern
    };
    let editorRaw;
    try {
        editorRaw = JSON.stringify(editorRawState);
    } catch (e) {}
    const data = _object_spread_props(_object_spread({}, snakeCaseBackgroundParams), {
        editorRaw,
        editor_v3: 'yes',
        statusid
    });
    const method = 'post';
    const url = isEdit ? '/status/update' : '/status/create';
    ddt.log('statusupdate', 'request', _object_spread_props(_object_spread({}, data), {
        url
    }));
    const result = yield call(requestNapi, {
        method,
        url,
        data
    }, fakeResponse);
    ddt.log('statusupdate', 'response', result);
    if (isApiError(result)) {
        if (result && result.errorCode === 302) {
            var _result_errorDetails;
            var _result_errorDetails_redirectUrl;
            window.location.replace((_result_errorDetails_redirectUrl = result === null || result === void 0 ? void 0 : (_result_errorDetails = result.errorDetails) === null || _result_errorDetails === void 0 ? void 0 : _result_errorDetails.redirectUrl) !== null && _result_errorDetails_redirectUrl !== void 0 ? _result_errorDetails_redirectUrl : '');
        }
        yield put(submitStatusFailure({
            error: result === null || result === void 0 ? void 0 : result.errorDescription
        }));
        ddt.log('statusupdate', 'failure', result);
        return;
    }
    // After save we have to publish it
    const publishData = {
        statusid: result.deviation.deviationId,
        tiers: (visibility === null || visibility === void 0 ? void 0 : visibility.type) === 'tier' ? visibility.tiers.map((tier)=>tier.deviationId) : undefined
    };
    const publishResult = yield call(requestNapi, {
        method: 'post',
        url: '/status/publish',
        data: publishData
    }, fakeResponse);
    ddt.log('statusupdate', 'response publish', publishResult);
    if (isApiError(publishResult)) {
        var _publishResult_errorDetails;
        if (publishResult.errorCode === 302 && ((_publishResult_errorDetails = publishResult.errorDetails) === null || _publishResult_errorDetails === void 0 ? void 0 : _publishResult_errorDetails.redirectUrl)) {
            window.location.replace(publishResult.errorDetails.redirectUrl);
        }
        yield put(submitStatusFailure({
            error: publishResult === null || publishResult === void 0 ? void 0 : publishResult.errorDescription
        }));
        ddt.log('statusupdate', 'failure', publishResult);
    }
    const resultActions = [
        put(submitStatusSuccess({
            statusId: publishResult.deviation.deviationId
        }))
    ];
    if (publishResult.deviation) {
        const { entities } = normalize(publishResult.deviation, deviationSchema);
        resultActions.push(put(putEntities({
            entities
        })));
    }
    if (!isEdit) {
        yield call(logBiEvent, PureBiData({
            evid: 11,
            group_exclusive: false,
            itemid: publishResult.deviation.deviationId,
            typeid: ResourceType.STATUS_DEVIATION
        }));
    }
    if (isEdit) {
        resultActions.push(put(editDeviationSuccess({
            deviation: publishResult.deviation
        })));
    }
    yield all(resultActions);
    ddt.log('statusupdate', 'success');
    // redirect
    if (refreshAfterSubmit) {
        window.location.reload();
    } else {
        const deviation = publishResult.deviation;
        window.location.assign(getDeviationUrl(deviation));
    }
}
function* deleteStatusSaga(action) {
    const isEditorV3 = yield select(flagEnabled, 'editor_journal_status');
    if (isEditorV3) {
        // go through unbranched saga
        return;
    }
    const { statusId: statusid } = action.payload;
    ddt.log('statusupdate', 'deleting', statusid);
    const result = yield call(requestPuppy, {
        method: 'post',
        url: `/status/delete`,
        data: {
            statusid
        }
    }, fakeResponse);
    ddt.log('statusupdate', 'response', result);
}
export default function* saga() {
    yield all([
        takeEvery(submitStatus, submitStatusSaga),
        takeEvery(deleteStatus, deleteStatusSaga)
    ]);
}

//# sourceMappingURL=saga.js.map